export enum LoadLibraryType {
  organization = 'ORGANIZATION',
  odyssey = 'ODYSSEY'
}
